/* eslint-disable no-param-reassign */
import { Mesh } from 'three';
import Experience from '../Experience.js';

export default class Room {
    constructor() {
        this.experience = new Experience();
        this.scene = this.experience.scene;
        this.resources = this.experience.resources;

        // Setup
        this.fileResource = this.resources.environments.room.file;
        this.setModel();
    }

    setModel() {
        this.model = this.fileResource.scene;
        this.scene.add(this.model);

        // this.model.traverse((child) => {
        //     if (child instanceof Mesh) {
        //         child.receiveShadow = true;
        //     }
        // });
    }
}
